module.exports = __webpack_public_path__ + "img/user_friendly.8c4ef0da.svg";